import React, { useCallback, useMemo } from 'react';
import { Button } from '@core/js/components/common/Button';
import { useFormatter } from '@core/js/hooks/useFormatter';
import style from './SuggestionItem.scss';

export const SuggestionItem = ({ suggestion, onClick, amount, isSuggestionHighlighted }) => {
    const formatter = useFormatter();

    const onClickHandler = useCallback(
        e => onClick(e.currentTarget.value),
        [onClick]
    );

    const isHighlighted = useMemo(() =>
            isSuggestionHighlighted && amount === suggestion,
        [amount, suggestion, isSuggestionHighlighted]
    );

    return (
        <li>
            <Button
                className={`${style.btn} ${isHighlighted ? style.highlighted : ''}` }
                onClick={onClickHandler}
                value={suggestion}
                view="primary"
                variant="rounded"
                color="info"
                size="small"
            >
                {formatter.formatNumber(suggestion, { precision: 0 })}
            </Button>
        </li>
    );
};
